import { Header, Text } from '@lightspeed/design-system-react'
import { T } from '@transifex/react'
import { VendImage } from '@vend/react-utilities'
import { reactular } from '@vendhq/reactular'
import React, { FunctionComponent } from 'react'

export const DuplicateWindow: FunctionComponent = () => {
  return (
    <div className="restricted-access">
      <div className="restricted-access-content">
        <VendImage
          relativeImagePath="sell/duplicate-window-v1.svg"
          className="vd-mb3 restricted-access-image"
        />
        <Header level="1" type="heading" className="vd-mb3">
          <T
            _str="You can only open one Sell tab at a time."
            _context="Header for duplicate window page"
          />
        </Header>
        <Text tag="p">
          <T
            _str="Having multiple Sell tabs open at the same time can cause errors in sales."
            _context="Text for duplicate window page"
          />
        </Text>
      </div>
    </div>
  )
}

export const DuplicateWindowComponent = reactular(
  DuplicateWindow,
  [],
  'reactWrapper'
)
